import { createSlice, current } from "@reduxjs/toolkit";

export const whiteListAccountsSlice = createSlice({
  name: "whiteListAccounts",
  initialState: {
    list : [],
  },
  reducers: {
    setwhiteListAccounts: (state, action) => {
      if(action.payload) state.list = action.payload
    },
    updateAccount: (state, action) => {
      if(action.payload) state.list = state.list.map((account) =>
      account.id == action.payload.id ? action.payload : account
      );
    },
    addAccount: (state,action)=>{
      let accountExists= state.list.find(x => x.id == action.payload.id)
      if(accountExists) console.log("account exists in Redux state, DROP: " + action.payload.id);
      if(action.payload && !accountExists) state.list.push(action.payload)
    },
    addAccounts: (state,action ) => {
      //avoid duplicates
      let noDuplicate = action.payload.map( (incommingAccount) => { // for every account in the input array
        if(!current(state.list).find(currentlyExistentAccount => currentlyExistentAccount.id == incommingAccount.id)){// finf if it's id already exist in the state
          return incommingAccount // if not rerurn that account that do not exist as result of map and save it in noDuplicate
        }
      }).filter(undefinedItem=>undefinedItem!== undefined)// for some reason an undefined is returned and because of that an undefineed item is added to the aray so we avoid that by filtering
      let updatedList = [...current(state.list),...noDuplicate];
      console.log("Updating whiteList: ", updatedList)
      // update the actual state
      state.list = updatedList
    }
  }
});

export default whiteListAccountsSlice.reducer

export const selectAllUsers =state=>state.whiteListAccountsSlice.list

export const {setwhiteListAccounts, updateAccount, addAccount,addAccounts} = whiteListAccountsSlice.actions